<template>
  <div
    :id="contentId"
    v-edit:block="contentId"
    class="title-text-block"
    :class="{'content-width': contentWidth, 'in-list': inList}"
  >
    <div class="content-wrapper">
      <h3
        v-if="title || isEditable"
        v-edit="'Title'"
      >
        {{ title }}
      </h3>
      <wysiwyg
        v-if="content || isEditable"
        v-edit="'Content'"
        :content="content"
        class="font-fixed"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "TitleTextBlock",
  props: {
    title: {
      type: String,
      default: ""
    },
    content: {
      type: [Array, String],
      default: () => []
    },
    contentId: {
      type: String,
      default: ""
    },
    contentWidth: {
      type: Boolean,
      default: false
    },
    inList: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">

.title-text-block {
  margin-bottom: 3rem;
  flex-direction: column;
  display: flex;

  @include font(text, 3, "normal");

  @include media-breakpoint-up(md) {
    flex-direction: row;
  }

  &.in-list {
    margin-top: 2em;
    margin-bottom: 0;
  }

  .content-wrapper {
    @include font(text, 3, "normal");

    h3 {
      @include font(rubrik, 2, "bold");
    }

    h2,
    h3 {
      margin-top: 0;
    }
  }
}

</style>
